exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-table th{\n    background:#F5F5F5 !important;\n    font-size:15px;\n}\n.ibox-content{\n        padding: 0 20px 20px 20px;\n        border:none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-be752bca","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/orgmgr/orgmgrwc.vue
// module id = OjjB
// module chunks = 5